import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import { CaptchaImage } from './styles/Captcha.styles';

const CaptchaControl = ({ control }) => (
  <ObjectWrapper>
    <CaptchaImage
      src={control.imageUrl}
      alt="Captcha Image"
    />
  </ObjectWrapper>
);

export default CaptchaControl;